import type { AdminScreenState } from "../../contracts/admin-screen-state";
import { pickAdminDashboardLocaleText } from "../locale/admin-dashboard-copy";
import type { AdminDashboardLocale } from "../locale/admin-dashboard-locale";

export function createAdminPermissionDeniedState<TViewModel>(
  locale: AdminDashboardLocale,
  copy: { en: string; ko: string },
  requestId: string,
): AdminScreenState<TViewModel> {
  return {
    status: "permission_denied",
    error: {
      code: "ADMIN_QUERY_PERMISSION_DENIED",
      message: pickAdminDashboardLocaleText(locale, copy),
      requestId,
    },
  };
}
